// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').directive('giOnLoad', () => ({
  restrict: 'A',

  link(scope, element, attrs) {
    return element.bind('load', () => scope.$apply(attrs.giOnLoad));
  },
}));
